import React from 'react';
import {
    Form, Input, Checkbox, Row, Col, Button, Modal,
    Upload, Icon, message, Spin, InputNumber
} from 'antd';
import SiderMenu from '@pages/Assembly/siderMenu';
import Breadcrumb from '@pages/Assembly/Breadcrumb';
import TitleTop from '@pages/Assembly/titleTop';
import CommonTip from "../common";
import { Flex } from '@components';
import NHFetch from "@utils/NHFetch";
import Hint from "@pages/SelfHelp/common/hint";
import { getLoginUser } from "@utils/NHCore";
import { mkbz } from "@pages/Assembly/siderMenu/menuObj";
import NextButton from '@pages/SelfHelp/common/nextIndex'
import NHFormItem from "@components/common/NHFormItem";

const formItemLayout = {
    labelCol: { span: 6 },
    wrapperCol: { span: 16 }
};

@Form.create()
export default class StuCampusCard extends React.Component {

    constructor(props) {
        super(props);
        this.state = {
            mkbz: 'GD049',
            hjmc: '',
            data: [],
            loading: false,
            nextUrl: '',//左侧菜单加载完后传进来
            search: '',
            operable: true,//是否显示环节
            nonOperationalData: {},//不可操作的数据
            blztFlag: "0",
            dataFlag: false,
        };
    }

    componentDidMount() {
        this.queryQztjAndYlhj();
        this.getData4Yxwz();
        //查询环节是否办理
        this.checkIsZzbdHjLinked()
    }

    //查询前置条件和依赖环节
    queryQztjAndYlhj = () => {
        let xsid = getLoginUser() ? getLoginUser().userId : '';
        if (!xsid) {
            this.setState({
                nonOperationalData: { nologin: true },
                operable: false,
            });
            return;
        }
        let zzbdhjid = this.getQueryString('pkid');
        NHFetch("/zzbd/queryQztjAndYlhj", 'GET', { xsid: xsid, zzbdhjid: zzbdhjid })
            .then(res => {
                if (res && res.data) {
                    let kfsj = res.data['kfsj'];
                    let ylhj = res.data['ylhj'];
                    let qzhj = res.data['qzhj'];
                    let nohj = res.data['nohj'];
                    this.setState({ nonOperationalData: res.data });
                    if (kfsj && kfsj['YXSJ'] != '1') {
                        this.setState({ operable: false });
                    } else if (ylhj && ylhj.length > 0) {
                        this.setState({ operable: false });
                    } else if (qzhj && qzhj.length > 0) {
                        this.setState({ operable: false });
                    } else if (nohj) {
                        this.setState({ operable: false });
                    }
                }
            });
    }

    setMenuList = (menuList) => {
        let nextCount = 0;
        let bz = this.state.mkbz;
        menuList.map((elem, index) => {
            if (elem.HJDM == bz) {
                let hjmc = elem.HJMC;
                let blztFlag = elem.BLZT;
                this.setState({ hjmc, blztFlag })
                nextCount = index + 1;
                return;
            }
        });
        let menu = menuList[nextCount];
        if (menu) {
            let hjdm = menu.HJDM;
            if (hjdm.indexOf('GD') == 0) {
                let gdUrl = mkbz[hjdm];
                this.setState({
                    nextUrl: gdUrl,
                    search: 'pkid=' + menu.PKID,
                })
            } else if (hjdm.indexOf('ZDY') == 0) {
                let zdyUrl = "/customLink";
                this.setState({
                    nextUrl: zdyUrl,
                    search: 'pkid=' + menu.PKID + '&mkbz=' + hjdm + '&lx=' + menu.LX,
                })
            }
        } else {
            this.setState({
                nextUrl: '',
                search: '',
            })
        }
    }

    //重新加载菜单
    reloadMenu = () => {
        this.refs.siderMenu.reloadMenuList()
    }

    getQueryString = (name) => {
        return decodeURIComponent((new RegExp('[?|&]' + name + '=' + '([^&;]+?)(&|#|;|$)').exec(location.href) || [, ''])[1].replace(/\+/g, '%20')) || null
    }

    getData4Yxwz = () => {
        let userId = getLoginUser() ? getLoginUser().userId : undefined;
        if (userId) {
            this.setState({ xsid: userId });
            NHFetch("/zzbd/xsxyk/queryStuInfoByXsid", "GET", { xsid: userId })
                .then((res) => {
                    if (res && res.data) {
                        this.setState({
                            dataFlag: true,
                            userBaseInfo: res.data
                        })
                    }
                })
        }
    }

    //查询环节是否办理
    checkIsZzbdHjLinked = () => {
        let xsid = getLoginUser() ? getLoginUser().userId : '';
        let zzbdhjid = this.getQueryString('pkid');

        return NHFetch("/zzbdCommon/checkIsZzbdHjLinked", 'GET', { xsid: xsid, zzbdhjid: zzbdhjid })
            .then(res => {
                if (res && res.code == 200) {
                    this.setState({ blztFlag: res.data ? "1" : "0" })
                    if (!res.data) {
                        //说明未办理 查询厂家办理状态
                        let userId = getLoginUser() ? getLoginUser().userId : undefined;
                        NHFetch("/zzbd/xsxyk/getStuHandlingInfor", "GET", { xsid: userId })
                            .then((res) => {
                                if (res.data) {
                                    if (res.data.code == 200) {
                                        //说明已经厂家办理了，需要自动办理该环节
                                        this.commonSaveLinkTransactionStatus();
                                    }
                                }
                            })
                    }
                }
                return res.data
            });
    };

    //自动办理环节
    commonSaveLinkTransactionStatus = () => {
        let xsid = getLoginUser() ? getLoginUser().userId : "";
        let zzbdhjid = this.getQueryString("pkid");
        let params = { xsid: xsid, zzbdhjid: zzbdhjid };
        NHFetch("/zzbdCommon/commonSaveLinkTransactionStatus", "POST", params).then(
            res => {
                if (res) {
                    if (res.data == 1) {
                        message.success("已确认办理");
                        if (res.data === 1) {
                            this.setState({ blztFlag: "1" });
                            this.reloadMenu();
                        }
                    }
                } else {
                    message.error("自动办理环节失败，请稍后重试！");
                }
            }
        );
    };

    handleSubmit = e => {
        const { userBaseInfo } = this.state;
        NHFetch("/zzbd/xsxyk/applyStuCampusCard", "POST", userBaseInfo)
            .then((res) => {
                if (res && res.data) {
                    window.open(res.data);
                }
            })
    }

    render() {
        const { blztFlag, dataFlag, userBaseInfo } = this.state;
        const { form } = this.props;
        const { getFieldDecorator } = this.props.form;

        return (
            <div>{this.state.operable ?
                <Flex className="w1180 mt-20" align="start">
                    <SiderMenu
                        ref={"siderMenu"}
                        setMenuList={this.setMenuList}
                        title="自助报到"
                        mkbz={this.state.mkbz}
                        menuType='自助报到'
                    />
                    <Flex.Item className="page_con_r" styleName="">
                        <Breadcrumb
                            noLine
                            list={[
                                { name: '首页', url: '/index' },
                                { name: '自助报到', url: '/register' },
                                { name: this.state.hjmc }
                            ]}
                        />
                        <div className="box">
                            <Hint />
                            <Form>
                                <TitleTop title="个人信息" extra={false} />
                                <div className="p-sw">
                                    <div className="form_item" style={{ width: '100%' }}>
                                        <Row gutter={24}>
                                            <Col span={4} style={{ textAlign: 'right', paddingRight: 0 }}><span
                                                style={{ color: 'rgba(0, 0, 0, 0.85)' }}>学生姓名&nbsp;: </span></Col>
                                            <Col span={20}><span>{userBaseInfo && userBaseInfo.XM}</span></Col>
                                        </Row>
                                        <br />
                                        <Row gutter={24}>
                                            <Col span={4} style={{ textAlign: 'right', paddingRight: 0 }}><span
                                                style={{ color: 'rgba(0, 0, 0, 0.85)' }}>学生身份证号码&nbsp;: </span></Col>
                                            <Col span={20}><span>{userBaseInfo && userBaseInfo.SFZJH}</span></Col>
                                        </Row>
                                        <br />
                                        <Row gutter={24}>
                                            <Col span={4} style={{ textAlign: 'right', paddingRight: 0 }}><span
                                                style={{ color: 'rgba(0, 0, 0, 0.85)' }}>联系电话&nbsp;: </span></Col>
                                            <Col span={20}><span>{userBaseInfo && userBaseInfo.SJHM}</span></Col>
                                        </Row>
                                        <br />
                                    </div>
                                </div>
                                <TitleTop title="申请办理" extra={false} />
                            </Form>
                            <div className="p-sw text-center mt-30">
                                {blztFlag == "0" && dataFlag &&
                                    <Button type="primary" onClick={this.handleSubmit}>
                                        申请办理
                                    </Button>
                                }
                                <NextButton nextUrl={this.state.nextUrl} search={this.state.search} />
                            </div>
                        </div>
                    </Flex.Item>
                </Flex>
                :
                <CommonTip hjmc={"学生校园卡申请"} key={'GD049'} mkbz='GD049' nonOperationalData={this.state.nonOperationalData} />
            }
            </div>
        );
    }

}